import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  SLIDE_FIELDS,
} from '../../constants/fieldGroups.constant'
import typeConstant from '../../constants/types.constant'
import AbstractCollection from '../Abstract/AbstractCollection'

const Videos = function () {
  return (
    <AbstractCollection
      collectionName="Videos"
      singleCollectionName="Video"
      notToShow={[
        'id',
        'ancestorIds',
        'parentId',
        'images',
        'videos',
        'type',
        'createdAt',
        'nameAr',
        'content',
        'contentAr',
        'coverPhoto',
        'coverImageAlt',
        'coverImageAltAr',
        'metaDescription',
        'metaDescriptionAr',
        'windowTitle',
        'windowTitleAr',
        ...SLIDE_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
      toShow={['name', 'status']}
      type={typeConstant.VIDEO}
    />
  )
}
export default Videos
